import { css, keyframes } from 'styled-components';
const DURATION = '1.5s';
const TIMING_FUNC = 'linear';
const ITERATION = 'infinite';
const SHIMMER_ANIMATION = keyframes(["100%{transform:translateX(100%);}"]);
export const animation = css(["animation:", " ", " ", " ", ";"], SHIMMER_ANIMATION, DURATION, TIMING_FUNC, ITERATION);